import React from "react";
import { useTranslation } from "react-i18next";
import staywithMonitor from "../../img/experience/staywith-monitor.svg";
import staywithPhone from "../../img/experience/staywith-phone.svg";
import staywithResponsive from "../../img/experience/staywith-responsive.svg";
import staywithRegister from "../../img/experience/staywith-register.svg";
import staywithDeposit from "../../img/experience/staywith-deposit.svg";
import staywithTrade from "../../img/experience/staywith-trade.svg";

const DESKTOP_CARDS = [
  {
    numKey: "exp.staywith.c1.num",
    titleKey: "exp.staywith.c1.title",
    descKey: "exp.staywith.c1.desc",
    bg: "bg-[#ffe6dc]",
    numColor: "text-[#ccc]",
    dotBg: "bg-[#f04e0a]",
    iconBg: "bg-[#ee5414]",
    titleColor: "text-[#0a0a0a]",
    descColor: "text-[#717171]",
    icon: staywithMonitor,
  },
  {
    numKey: "exp.staywith.c2.num",
    titleKey: "exp.staywith.c2.title",
    descKey: "exp.staywith.c2.desc",
    bg: "bg-[#0a0a0a]",
    numColor: "text-[#444]",
    dotBg: "bg-[#f04e0a]",
    iconBg: "bg-white",
    titleColor: "text-white",
    descColor: "text-[#717171]",
    icon: staywithPhone,
  },
  {
    numKey: "exp.staywith.c3.num",
    titleKey: "exp.staywith.c3.title",
    descKey: "exp.staywith.c3.desc",
    bg: "bg-[#f04e0a]",
    numColor: "text-[#f7a684]",
    dotBg: "bg-white",
    iconBg: "bg-[#0a0a0a]",
    titleColor: "text-white",
    descColor: "text-[#fbd3c2]",
    icon: staywithResponsive,
  },
];

const MOBILE_CARDS = [
  {
    num: "01",
    titleKey: "exp.staywith.step1.title",
    descKey: "exp.staywith.step1.desc",
    bg: "#fcefea",
    numColor: "text-[#ccc]",
    dotBg: "bg-[#f04e0a]",
    iconBg: "bg-[#ee5414]",
    titleColor: "text-[#0a0a0a]",
    descColor: "text-[#888]",
    icon: staywithRegister,
  },
  {
    num: "02",
    titleKey: "exp.staywith.step2.title",
    descKey: "exp.staywith.step2.desc",
    bg: "#0a0a0a",
    numColor: "text-[#444]",
    dotBg: "bg-[#f04e0a]",
    iconBg: "bg-white",
    titleColor: "text-white",
    descColor: "text-[#666]",
    icon: staywithDeposit,
  },
  {
    num: "03",
    titleKey: "exp.staywith.step3.title",
    descKey: "exp.staywith.step3.desc",
    bg: "#f04e0a",
    numColor: "text-[rgba(255,255,255,0.5)]",
    dotBg: "bg-white",
    iconBg: "bg-[#0a0a0a]",
    titleColor: "text-white",
    descColor: "text-[rgba(255,255,255,0.75)]",
    icon: staywithTrade,
  },
];

function StayWith() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col gap-[40px] xl:gap-[60px]">
        {/* Header */}
        <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-[20px]">
          <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none xl:max-w-[504px]">
            {t("exp.staywith.title")}
          </h2>
          <p className="hidden xl:block font-['Inter'] font-normal text-[18px] text-[#717171] leading-[1.4] max-w-[600px]">
            {t("exp.staywith.desc")}
          </p>
        </div>

        {/* Desktop cards: Desktop/Mobile/Unified Access with Figma icons */}
        <div className="hidden xl:flex gap-[20px]">
          {DESKTOP_CARDS.map((card, i) => (
            <div key={i} className={`${card.bg} rounded-[20px] flex flex-col gap-[40px] p-[30px] pb-[51px] flex-1`}>
              <div className="flex items-center justify-between">
                <span className={`font-['Montserrat'] font-bold text-[13px] tracking-[1.3px] ${card.numColor}`}>
                  {t(card.numKey)}
                </span>
                <div className={`${card.dotBg} rounded-[7px] size-[14px] shrink-0`} />
              </div>
              <div className="flex flex-col gap-[40px]">
                <div className={`${card.iconBg} rounded-[40px] size-[52px] flex items-center justify-center shrink-0`}>
                  <img src={card.icon} alt="" aria-hidden className="size-[24px]" />
                </div>
                <div className="flex flex-col gap-[12px]">
                  <h3 className={`font-['Montserrat'] font-black text-[32px] tracking-[-0.76px] uppercase leading-[1.2] ${card.titleColor}`}>
                    {t(card.titleKey)}
                  </h3>
                  <p className={`font-['Inter'] font-normal text-[16px] leading-[1.4] ${card.descColor}`}>
                    {t(card.descKey)}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile cards: Register/Deposit/Trade steps */}
        <div className="xl:hidden flex flex-col gap-[12px]">
          {MOBILE_CARDS.map((card, i) => (
            <div key={i} className="relative h-[170px] rounded-[20px] overflow-hidden" style={{ backgroundColor: card.bg }}>
              {/* number + dot */}
              <div className="absolute top-[30px] left-[36px] right-[36px] flex justify-between items-center">
                <span className={`font-['Montserrat'] font-bold text-[13px] tracking-[1.3px] ${card.numColor}`}>{card.num}</span>
                <div className={`rounded-[7px] size-[14px] ${card.dotBg}`} />
              </div>
              {/* icon circle */}
              <div className={`absolute ${card.iconBg} rounded-[40px] size-[52px] flex items-center justify-center`} style={{ top: "73px", left: "36px" }}>
                <img src={card.icon} alt="" aria-hidden className="size-[24px]" />
              </div>
              {/* heading */}
              <span className={`absolute font-['Montserrat'] font-black text-[24px] tracking-[-0.76px] uppercase leading-[38px] ${card.titleColor}`} style={{ top: "66px", left: "108px", right: "36px" }}>
                {t(card.titleKey)}
              </span>
              {/* desc */}
              <span className={`absolute font-['Inter'] font-normal text-[14px] leading-[1.4] ${card.descColor}`} style={{ top: "104px", left: "108px", right: "36px" }}>
                {t(card.descKey)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default StayWith;
